import { useState, useEffect } from "react";
import { getProject } from "../services/projectService";

interface ApiError {
  message?: string;
}

const useGetProject = (projectId: string | undefined) => {
  const [projectData, setProjectData] = useState<Record<string, unknown> | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!projectId) return;

    let cancelled = false;

    const fetchData = async () => {
      setLoading(true);
      setError("");

      const { data, error: apiError } = await getProject(projectId) as {
        data: { data?: Record<string, unknown> } | null;
        error: ApiError | null;
      };

      if (cancelled) return;
      setLoading(false);

      if (apiError) {
        setError(apiError.message || "Failed to load project.");
        return;
      }

      setProjectData((data?.data ?? data ?? null) as Record<string, unknown> | null);
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [projectId]);

  return { projectData, loading, error };
};

export default useGetProject;
